import React from 'react';
import { styled } from '@mui/material/styles';
import { FormGroup,
    FormControlLabel,
    Switch } from '@mui/material';

const CustomizedSwitch = styled((props) => (
    <Switch disableRipple focusVisibleClassName=".Mui-focusVisible" {...props} />
))(({ theme }) => ({
    width: 36,
    height: 20,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#8C3F7D',
                opacity: 1,
                border: 0
            },
            '&.Mui-disabled + .MuiSwitch-track': { opacity: 0.5 }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff'
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600]
        },
        '&.Mui-disabled + .MuiSwitch-track': { opacity: theme.palette.mode === 'light' ? 0.7 : 0.3 }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#98A2B3',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], { duration: 500 })
    }
}));

const CustomSwitch = (props) => {
    const {
        label = '', checked = false, onChange, id, ...rest 
    } = props;

    const handleOnChange = (event) => {
        const newValue = typeof event === 'boolean' ? event : event.target.checked;
      
        if (id !== undefined) {
            onChange(id, newValue);
        } else {
            onChange(newValue);
        }
    };
      

    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <CustomizedSwitch
                        checked={checked}
                        sx={{ m: 1 }}
                        onChange={handleOnChange}
                        {...rest}
                    />
                }
                label={label}
            />
        </FormGroup>
    );
};


export default CustomSwitch;